import styled from 'styled-components';

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  font-family: 'Inter';
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  margin: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-family: 'Inter';
`;

export const ModalBody = styled.div`
  padding: 24px;
  text-align: center;
  font-family: 'Inter';
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  font-family: 'Inter';

  button:first-child {
    font-weight: 400;
  }
`;

export const Title = styled.h2`
  margin: 0 0 16px 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  font-family: 'Inter';
`;

export const Message = styled.p`
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  font-family: 'Inter';

  strong {
    font-weight: 600;
    font-family: 'Inter';
  }
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  font-family: 'Inter';
`; 